import { fromJS } from 'immutable';

// eslint-disable-next-line import/prefer-default-export
export const ListProductDemo = fromJS([
  {
    id: 6020608000150,
    title: '3/4 Sleeve Kimono Dress',
    body_html: `<p><em>This is a demonstration store. You can purchase products like this from <a href="http://babyandco.us/" target="_blank">Baby &amp; Company</a></em></p> <p><span>The Kimono Dress by Antoni and Alison embarks a cascade of color and collage. Flowing, 3/4 inch sleeves. Wide boat neckline. Side angled pockets at front. Lining. </span>Color Coral. 100% Silk. Made in the U.K. <em>Ashley is wearing a Size 8.</em></p>`,
    handle: '3-4-sleeve-kimono-dress-coral',
    variants: [
      {
        id: 37376353599638,
        title: '8',
        price: '552',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37376353632406,
        title: '10',
        price: '552',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376353665174,
        title: '12',
        price: '552',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376353730710,
        title: '14',
        price: '552',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376353763478,
        title: '16',
        price: '552',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      }
    ],
    images: [
      {
        id: 20416148242582,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-20_Ashley_Look_20_23515_15565.jpg?v=1608611062'
      },
      {
        id: 20416148275350,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-20_Ashley_Look_20_23515_15563.jpg?v=1608611062'
      },
      {
        id: 20416148308118,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-20_Ashley_Look_20_23515_15567.jpg?v=1608611062'
      },
      {
        id: 20416148340886,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-20_Ashley_Look_20_23515_15571.jpg?v=1608611062'
      },
      {
        id: 20416148373654,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-20_Ashley_Look_20_23515_15573.jpg?v=1608611062'
      },
      {
        id: 20416148406422,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-20_Ashley_Look_20_23515_15574.jpg?v=1608611062'
      }
    ],
    image: {
      id: 20416148242582,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-20_Ashley_Look_20_23515_15565.jpg?v=1608611062'
    }
  },
  {
    id: 6020631888022,
    title: '5 Pocket Jean',
    body_html: `<p><em>This is a demonstration store. You can purchase products like this from <a href="http://babyandco.us/" target="_blank">Baby &amp; Company</a></em></p><p>The 5 Pocket Jean by Nigel Cabourn is your denim go-to for every occasion. <span>Cut from a stiff and irregular selvage denim, the shape of the leg resembles the original work denim, complete with a riveted copper cinch-back strap in back. </span>Button fly closure at front. Color Indigo. 100% Cotton. Made in Japan. <em>Jacob is wearing a 32.</em></p>`,
    handle: '5-pocket-jean',
    variants: [
      {
        id: 37376443842710,
        title: '30 / Indigo',
        price: '405',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376443908246,
        title: '32 / Indigo',
        price: '405',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376444006550,
        title: '34 / Indigo',
        price: '405',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      }
    ],
    images: [
      {
        id: 20416254247062,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-04-03_Jake_Look_08_32020_18028.jpg?v=1608611798'
      },
      {
        id: 20416254279830,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-04-03_Jake_Look_09_30295_18046.jpg?v=1608611798'
      },
      {
        id: 20416254312598,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-04-03_Jake_Look_08_32020_18021.jpg?v=1608611798'
      },
      {
        id: 20416254345366,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-04-03_Jake_Look_09_30295_18035.jpg?v=1608611798'
      },
      {
        id: 20416254378134,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-06_Addis_Look_01_30185_9758.jpg?v=1608611798'
      },
      {
        id: 20416254410902,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-06_Addis_Look_01_30185_9788.jpg?v=1608611798'
      }
    ],
    image: {
      id: 20416254247062,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-04-03_Jake_Look_08_32020_18028.jpg?v=1608611798'
    }
  },
  {
    id: 6020696998038,
    title: 'A-Line Jacket',
    body_html:
      '<p><em>This is a demonstration store. You can purchase products like this from <a href="http://babyandco.us/" target="_blank">Baby &amp; Company</a></em></p><p>The A-Line Jacket by Co. offers structural ease for a polished look. Added linen presents added texture and gorgeous interest. Covered, snap button closure at front. Full lined. Color Black. 72% Viscose, 28% Linen, Lining 100% Polyester.</p>',
    handle: 'a-line-jacket-in-black',
    variants: [
      {
        id: 37377002963094,
        title: 'X-Small / Black',
        price: '699',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377002995862,
        title: 'Small / Black',
        price: '699',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377003028630,
        title: 'Medium / Black',
        price: '699',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      }
    ],
    images: [
      {
        id: 20416602734742,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-26_Ashley_Look_28_20557_7133.jpg?v=1608614570'
      },
      {
        id: 20416602767510,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-26_Ashley_Look_29_20566_7292.jpg?v=1608614570'
      },
      {
        id: 20416602800278,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-26_Ashley_Look_28_20557_7128.jpg?v=1608614570'
      },
      {
        id: 20416602833046,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-26_Ashley_Look_29_20566_7310.jpg?v=1608614570'
      },
      {
        id: 20416602865814,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-26_Ashley_Look_29_20566_7300.jpg?v=1608614570'
      },
      {
        id: 20416602898582,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-26_Ashley_Look_28_20557_7147.jpg?v=1608614570'
      }
    ],
    image: {
      id: 20416602734742,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-26_Ashley_Look_28_20557_7133.jpg?v=1608614570'
    }
  },
  {
    id: 6020714496150,
    title: 'A-Line Mini Dress in Blue',
    body_html: `<meta charset="utf-8"> <style type="text/css"><!-- &lt;!-- &amp;lt;!-- &amp;amp;lt;!-- &amp;amp;amp;lt;!-- &amp;amp;amp;amp;amp;lt;!-- &amp;amp;amp;amp;amp;amp;lt;!-- &amp;amp;amp;amp;amp;amp;amp;lt;!-- td {border: 1px solid #ccc;}br {mso-data-placement:same-cell;} --&amp;amp;amp;amp;amp;amp;amp;gt; --&amp;amp;amp;amp;amp;amp;gt; --&amp;amp;amp;amp;amp;gt; --&amp;amp;amp;gt; --&amp;amp;gt; --&amp;gt; --&gt; --></style> <p><span data-sheets-value='[null,2,"Nothing is cooler than a pacifying shade of silvery blue. This mini features a back low cut scoop neck and invisible zipper closure. Color Blue. 49% Wool, 39% Polyester, 12% Silk."]' data-sheets-userformat="[null,null,8961,[null,0],null,null,null,null,null,null,null,1,0,null,null,null,11]">Nothing is cooler than a pacifying shade of silvery blue. This mini by Aspesi features a back low cut scoop neck and invisible zip closure. Color Blue. 49% Wool, 39% Polyester, 12% Silk. </span><em style="line-height: 1.2;"><span data-sheets-value='[null,2,"Nothing is cooler than a pacifying shade of silvery blue. This mini features a back low cut scoop neck and invisible zip closure. Color Blue. 49% Wool, 39% Polyester, 12% Silk."]' data-sheets-userformat="[null,null,8961,[null,0],null,null,null,null,null,null,null,1,0,null,null,null,11]">Lana is wearing an Italian 40. </span></em></p>`,
    handle: 'a-line-mini-dress-blue',
    variants: [
      {
        id: 37377220739222,
        title: 'Blue / Italian 40',
        price: '348',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377220771990,
        title: 'Blue / Italian 42',
        price: '348',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377220804758,
        title: 'Blue / Italian 44',
        price: '348',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      }
    ],
    images: [
      {
        id: 20416742097046,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_18_Lana_Look2704.jpg?v=1608615561'
      },
      {
        id: 20416742129814,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_18_Lana_Look2701.jpg?v=1608615561'
      },
      {
        id: 20416742162582,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_18_Lana_Look2703.jpg?v=1608615561'
      },
      {
        id: 20416742195350,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_18_Lana_Look2705.jpg?v=1608615561'
      }
    ],
    image: {
      id: 20416742097046,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_18_Lana_Look2704.jpg?v=1608615561'
    }
  },
  {
    id: 6020727373974,
    title: 'A-Line Pocket Shift in Black',
    body_html: `<meta charset="utf-8"><meta charset="utf-8"> <p><span>This shift dress possesses many virtues. This A-line by Mauro Grifoni, v-neck version has convenient side seam pockets, an invisible zip closure and back darts for a tailored fit. Color Black. 80% Polyester, 14% Viscose. Made in Italy. </span><em>Lana is wearing an Italian 38.</em></p>`,
    handle: 'a-line-pocket-shift-black',
    variants: [
      {
        id: 37377319141526,
        title: 'Black / Italian 38',
        price: '298',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377319174294,
        title: 'Black / Italian 40',
        price: '298',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377319207062,
        title: 'Black / Italian 42',
        price: '298',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377319239830,
        title: 'Black / Italian 44',
        price: '298',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377319272598,
        title: 'Black / Italian 46',
        price: '298',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      }
    ],
    images: [
      {
        id: 20416807698582,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_25_Lana_Look5_01.jpg?v=1608615985'
      },
      {
        id: 20416807731350,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_25_Lana_Look5_04.jpg?v=1608615985'
      },
      {
        id: 20416807764118,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_25_Lana_Look5_06.jpg?v=1608615985'
      },
      {
        id: 20416807796886,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_25_Lana_Look5_08.jpg?v=1608615985'
      },
      {
        id: 20416807829654,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_25_Lana_Look5_07.jpg?v=1608615985'
      },
      {
        id: 20416807862422,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_25_Lana_Look5_09.jpg?v=1608615985'
      }
    ],
    image: {
      id: 20416807698582,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_10_25_Lana_Look5_01.jpg?v=1608615985'
    }
  },
  {
    id: 6020690837654,
    title: 'ACB Top',
    body_html: `<p><em>This is a demonstration store. You can purchase products like this from <a href="http://babyandco.us/" target="_blank">Baby &amp; Company</a></em></p><p> Spring forward with glorious enthusiasm for summer with Jesse Kamm's ACB Top. The line is charming and easy, with hints of nautical inspiration. Open back with V. Button placket closure at center back. Color Brick. 45% Tencel, 40% Cotton, 15% Flax. Made in U.S.A. <em>Ashley is wearing an X-Small.</em></p>`,
    handle: 'acb-top-in-chipped-brick',
    variants: [
      {
        id: 37376959283350,
        title: 'X-Small / Brick',
        price: '279',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37376959316118,
        title: 'Small / Brick',
        price: '279',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      }
    ],
    images: [
      {
        id: 20416556728470,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-19_Ashley_Look_34_20818_6039_1.jpg?v=1608614344'
      },
      {
        id: 20416556761238,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-19_Ashley_Look_34_20818_6035.jpg?v=1608614344'
      },
      {
        id: 20416556794006,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-19_Ashley_Look_34_20818_6039.jpg?v=1608614344'
      },
      {
        id: 20416556826774,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-19_Ashley_Look_34_20818_6050_1.jpg?v=1608614344'
      }
    ],
    image: {
      id: 20416556728470,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-19_Ashley_Look_34_20818_6039_1.jpg?v=1608614344'
    }
  },
  {
    id: 6020571201686,
    title: 'Adania Pant',
    body_html: `<p><em>This is a demonstration store. You can purchase products like this from <a href="http://babyandco.us/" target="_blank">Baby &amp; Company</a></em></p><p>Super stretch Adaina Pant offers the classic skinny with all the fun bits. Zip closure at back with concealed zip openings at ankles. By Malene Birger. Color Blue.  90% Polyamide, 10% Elastane. Made in China. <em>Ashley is wearing a European 36. </em></p>`,
    handle: 'adania-pant',
    variants: [
      {
        id: 37376217448598,
        title: 'Blue / 34',
        price: '368',
        compare_at_price: '368',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37376217481366,
        title: 'Blue / 36',
        price: '368',
        compare_at_price: '368',
        image_id: 0,
        inventory_quantity: 2
      },
      {
        id: 37376217514134,
        title: 'Blue / 38',
        price: '368',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 2
      },
      {
        id: 37376217546902,
        title: 'Blue / 40',
        price: '368',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376217579670,
        title: 'Blue / 42',
        price: '368',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      }
    ],
    images: [
      {
        id: 20416034111638,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-06-11-Ashley_Look10_50102_23612.jpg?v=1608610026'
      },
      {
        id: 20416034144406,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-06-11-Ashley_Look10_50102_23624.jpg?v=1608610026'
      },
      {
        id: 20416034177174,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-06-11-Ashley_Look10_50102_23627.jpg?v=1608610026'
      },
      {
        id: 20416034209942,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-06-11-Ashley_Look10_50102_23628.jpg?v=1608610026'
      }
    ],
    image: {
      id: 20416034111638,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-06-11-Ashley_Look10_50102_23612.jpg?v=1608610026'
    }
  },
  {
    id: 6020714659990,
    title: 'Alex Twill Pant in Mariner',
    body_html: `<meta charset="utf-8"><meta charset="utf-8"> <p><span>Richly dyed cotton sets off cleanly styled, incredibly soft pants cut with a straight leg and classic five-pocket style by Homecore. Color Mariner. 98% Cotton. </span><em>Addis is wearing a size 31. </em><em><em>Addis is 6’2”, Chest 38.5”, Waist 31”, Inseam 32”.</em></em></p> <p><em>Also available in <a href="http://babyandco.us/products/alex-twill-pant-sand">Sand</a>, </em><i><a href="http://babyandco.us/products/alex-twill-pant-bordeaux">Bordeaux</a>, <a href="http://babyandco.us/products/alex-twill-pant-dark-grey">Dark Grey</a>, and <a href="http://babyandco.us/products/alex-twill-pant-navy">Navy</a>. </i></p> <p><a href="http://babyandco.us/collections/vendors?q=Homecore"><em>Shop our collection of Homecore.</em></a></p>`,
    handle: 'alex-twill-pant-mariner',
    variants: [
      {
        id: 37377224179862,
        title: 'Mariner / 29',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377224212630,
        title: 'Mariner / 30',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377224245398,
        title: 'Mariner / 31',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 2
      },
      {
        id: 37377224278166,
        title: 'Mariner / 32',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377224310934,
        title: 'Mariner / 33',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377224343702,
        title: 'Mariner / 34',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377224376470,
        title: 'Mariner / 36',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      }
    ],
    images: [
      {
        id: 20416743047318,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014-09-04_Addis_Look_05_33_e5bd1ec6-f6f0-41b1-b0b1-afd6f0e527be.jpg?v=1608615570'
      },
      {
        id: 20416743080086,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014-09-04_Addis_Look_05_34.jpg?v=1608615570'
      },
      {
        id: 20416743112854,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014-09-04_Addis_Look_05_29_4b82bf39-d8c5-47cc-ac3a-01438e8be9a9.jpg?v=1608615570'
      },
      {
        id: 20416743145622,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014-09-04_Addis_Look_05_30_eb9a3c76-1eda-436c-a4e7-cfedc220e6bd.jpg?v=1608615570'
      }
    ],
    image: {
      id: 20416743047318,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014-09-04_Addis_Look_05_33_e5bd1ec6-f6f0-41b1-b0b1-afd6f0e527be.jpg?v=1608615570'
    }
  },
  {
    id: 6020714692758,
    title: 'Alex Twill Pant in Navy',
    body_html: `<meta charset="utf-8"> <p><span>Richly dyed cotton sets off cleanly styled, incredibly soft pants cut with a straight leg and classic five-pocket style by Homecore. Color Navy. 98% Cotton. <em>Addis is wearing a size 31. </em></span><em>Addis is 6’2”, Chest 38.5”, Waist 31”, Inseam 32”.</em></p> <p><em>Also available in <a href="http://babyandco.us/products/alex-twill-pant-sand">Sand</a>, </em><i><a href="http://babyandco.us/products/alex-twill-pant-bordeaux">Bordeaux</a>, <a href="http://babyandco.us/products/alex-twill-pant-dark-grey">Dark Grey</a>, and <a href="http://babyandco.us/products/alex-twill-pant-mariner">Mariner</a>.</i></p> <p><a href="http://babyandco.us/collections/vendors?q=Homecore"><em>Shop our collection of Homecore.</em></a></p>`,
    handle: 'alex-twill-pant-navy',
    variants: [
      {
        id: 37377224474774,
        title: 'Navy / 29',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377224507542,
        title: 'Navy / 30',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377224540310,
        title: 'Navy / 31',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37377224573078,
        title: 'Navy / 32',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377224605846,
        title: 'Navy / 33',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377224638614,
        title: 'Navy / 34',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37377224671382,
        title: 'Navy / 36',
        price: '198',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      }
    ],
    images: [
      {
        id: 20416743702678,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_11_3_Addis_Look14_01.jpg?v=1608615577'
      },
      {
        id: 20416743735446,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_11_3_Addis_Look14_02.jpg?v=1608615577'
      },
      {
        id: 20416743768214,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_11_3_Addis_Look14_03.jpg?v=1608615577'
      },
      {
        id: 20416743800982,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_11_3_Addis_Look14_04.jpg?v=1608615577'
      }
    ],
    image: {
      id: 20416743702678,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2014_11_3_Addis_Look14_01.jpg?v=1608615577'
    }
  },
  {
    id: 6020693459094,
    title: 'Alex Twill Pant in Sand',
    body_html: `<p><em>This is a demonstration store. You can purchase products like this from <a href="http://babyandco.us/" target="_blank">Baby &amp; Company</a></em></p><p><span style="line-height: 1.4;">Richly dyed cotton sets off cleanly styled, incredibly soft pants cut with a straight leg and classic five-pocket style by Homecore. Color Sand. 98% Cotton, 2% Lycra. Made in Portugal. <em>Jacob os wearing a 34.</em></span></p>`,
    handle: 'alex-twill-pant-sand',
    variants: [
      {
        id: 37376978059414,
        title: '30 / Sand',
        price: '228',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376978092182,
        title: '31 / Sand',
        price: '228',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      },
      {
        id: 37376978124950,
        title: '32 / Sand',
        price: '228',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 2
      },
      {
        id: 37376978157718,
        title: '33 / Sand',
        price: '228',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376978190486,
        title: '34 / Sand',
        price: '228',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376978223254,
        title: '36 / Sand',
        price: '228',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 0
      }
    ],
    images: [
      {
        id: 20416575373462,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-30_Jake_Look_16_20656_16536.jpg?v=1608614445'
      },
      {
        id: 20416575406230,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-30_Jake_Look_16_20656_16533.jpg?v=1608614445'
      },
      {
        id: 20416575438998,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-30_Jake_Look_16_20656_16539.jpg?v=1608614445'
      },
      {
        id: 20416575471766,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-30_Jake_Look_16_20656_16545.jpg?v=1608614445'
      }
    ],
    image: {
      id: 20416575373462,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-03-30_Jake_Look_16_20656_16536.jpg?v=1608614445'
    }
  },
  {
    id: 6020660887702,
    title: 'Alia Knit Trouser',
    body_html: `<p><em>This is a demonstration store. You can purchase products like this from <a href="http://babyandco.us/" target="_blank">Baby &amp; Company</a></em></p><p>True versatility of pieces, the collection is diverse yet harmonizing with each other. The Alia Knit Trouser by Annette Gortz is essentially a classy sweat pant. Draw string waist band. Side angled pockets at front. Tapered leg with a subtle racing stripe. Color Black. 96% Viscose, 4% Polyester. Made in Germany. <em>Ashley is wearing an X Small.</em></p>`,
    handle: 'alia-knit-trouser-1',
    variants: [
      {
        id: 37376677806230,
        title: 'X Small / Black',
        price: '608',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376677838998,
        title: 'Small / Black',
        price: '608',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376677871766,
        title: 'Medium / Black',
        price: '608',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 3
      },
      {
        id: 37376677904534,
        title: 'Large / Black',
        price: '608',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      },
      {
        id: 37376677937302,
        title: 'X Large / Black',
        price: '608',
        compare_at_price: '',
        image_id: 0,
        inventory_quantity: 1
      }
    ],
    images: [
      {
        id: 20416394461334,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-05_Ashley_Look_37_30119_2520.jpg?v=1608612978'
      },
      {
        id: 20416394494102,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-05_Ashley_Look_37_30119_2525.jpg?v=1608612978'
      },
      {
        id: 20416394526870,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-05_Ashley_Look_37_30119_2526.jpg?v=1608612978'
      },
      {
        id: 20416394559638,
        src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-05_Ashley_Look_37_30119_2527.jpg?v=1608612978'
      }
    ],
    image: {
      id: 20416394461334,
      src: 'https://cdn.shopify.com/s/files/1/0521/6996/5718/products/2015-02-05_Ashley_Look_37_30119_2520.jpg?v=1608612978'
    }
  }
]);
